import {fromJsonObject, usingJsonToModelConvertor} from "../decorators";
import {Model} from "../Model";
import Category from "./Category";
import {Product} from "./Product";

@usingJsonToModelConvertor
export class ProductAndItsCategory extends Model{

    @fromJsonObject({key: "category", modelClass: Category, isArray: false})
    public category! :Category;

    @fromJsonObject({key: "products", modelClass: Product, isArray: true})
    public products! :Product[];

}
